// extracted by mini-css-extract-plugin
module.exports = {"container":"_1JGEQKOI4FCjZNWL-dqPbs","iconContainer":"_1yGKPu8KQvgiMB_WJY_ZeD","title":"_3a7ge7wQDmX8AZ8s2nGT_G","retryButton":"_2SXCs17t5XUTkttyw33U-m"};